import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We use the Composition API as it provides better accessibility, maintainability, and type safety.`}</p>
    <p>{`Start by creating a `}<inlineCode parentName="p">{`composables`}</inlineCode>{` folder as well as a `}<inlineCode parentName="p">{`usePosthog.js`}</inlineCode>{` file to that folder. In `}<inlineCode parentName="p">{`usePosthog.js`}</inlineCode>{`, initialize PostHog as a composable with your project API key and host. You can find these in your `}<a parentName="p" {...{
        "href": "https://us.posthog.com/project/settings"
      }}>{`project settings`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/composables/usePostHog.ts
import posthog from 'posthog-js'

export function usePostHog() {
  posthog.init('<ph_project_api_key>', {
    api_host: '<ph_client_api_host>',
    defaults: '<ph_posthog_js_defaults>',
  })

  return { posthog }
}
`}</code></pre>
    <p>{`Next, in `}<inlineCode parentName="p">{`router/index.js`}</inlineCode>{`, import the `}<inlineCode parentName="p">{`usePostHog`}</inlineCode>{` composable and call it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { usePostHog } from '@/composables/usePostHog'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
    },
  ],
})

const { posthog } = usePostHog()

export default router
`}</code></pre>
    <p>{`Once done, PostHog will begin `}<a parentName="p" {...{
        "href": "/docs/product-analytics/autocapture"
      }}>{`autocapturing`}</a>{` events and pageviews (if enabled) and is ready to use throughout your app.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      